import { InboxOutlined } from '@ant-design/icons';

import styles from './styles.module.css';

export const EmptyList = () => {
  return (
    <div className={styles.wrapper}>
      <InboxOutlined className={styles.icon} />
      <p className={styles.text}>Não localizamos nenhum participante com os dados informados.</p>
      <p className={styles.subtext}>
        Verifique os dados digitados e tente novamente. Lembrando que você pode buscar pelo nome, código do ingresso,
        número da fatura ou CPF/CNPJ do participante.
      </p>
    </div>
  );
};
